import { logoAspaec, logoRemederi, logoVikura } from '@cannect/assets/img/brands'
import { BrandKey } from '../../../config/brands.config'

const BRAND_HEADER_LOGOS: Partial<Record<BrandKey, string>> = {
  aspaec: logoAspaec,
  remederi: logoRemederi,
  vikura: logoVikura
}

export const getBrandHeaderLogo = (key: BrandKey): string => {
  return BRAND_HEADER_LOGOS[key] ?? logoAspaec
}
